var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.771 2.439 1.076-.344c1.01-.322 2.087.199 2.52 1.217l.86 2.028c.373.883.165 1.922-.515 2.568L9.817 9.706c.117 1.076.48 2.135 1.085 3.177a8.678 8.678 0 0 0 2.27 2.595l2.276-.76c.862-.287 1.802.044 2.33.82l1.233 1.81c.615.905.504 2.15-.259 2.917l-.817.82c-.814.818-1.977 1.115-3.052.779-2.54-.792-4.873-3.143-7.003-7.053-2.133-3.916-2.886-7.24-2.258-9.968.264-1.148 1.081-2.063 2.15-2.404Z",
    fill: "#fff"
  })));
};

export default SvgPhone;